import apiClient from "@/services/api-client";
import type {
  SupportAssignee,
  SupportMessagePayload,
  SupportTicketDetail,
  SupportTicketListQuery,
  SupportTicketListResponse,
  SupportTicketUpdatePayload,
} from "@/types";

function idempotencyKey() {
  return crypto.randomUUID();
}

export const supportService = {
  listTickets: async (params: SupportTicketListQuery) => {
    const response = await apiClient.get<SupportTicketListResponse>(
      "/support/tickets",
      { params },
    );
    return response.data;
  },
  getTicket: async (id: string) => {
    const response = await apiClient.get<SupportTicketDetail>(
      `/support/tickets/${id}`,
    );
    return response.data;
  },
  updateTicket: async (id: string, payload: SupportTicketUpdatePayload) => {
    const response = await apiClient.patch<SupportTicketDetail>(
      `/support/tickets/${id}`,
      payload,
      { headers: { "Idempotency-Key": idempotencyKey() } },
    );
    return response.data;
  },
  addMessage: async (id: string, payload: SupportMessagePayload) => {
    const response = await apiClient.post<SupportTicketDetail>(
      `/support/tickets/${id}/messages`,
      payload,
      { headers: { "Idempotency-Key": idempotencyKey() } },
    );
    return response.data;
  },
  listAssignees: async () => {
    const response =
      await apiClient.get<SupportAssignee[]>("/support/assignees");
    return response.data;
  },
};
